
import { Component, OnInit } from '@angular/core';
import { faChevronRight, faPencil, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ResolutionsService } from 'src/app/services/resolutions.service';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService } from 'src/app/services/event.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from '../../core/constant/common.constant';
import { Constants } from 'src/app/constants';
import { DatePipe } from '@angular/common';
import { EditBtnRendererComponent } from 'src/app/core/grid-renderer/edit-btn-renderer/edit-btn-renderer.component';
import { FilterChangedEvent, GridOptions } from 'ag-grid-community';
import { EditResolutionComponent } from 'src/app/core/check/edit-resolution/edit-resolution.component';
import { AddBtnRendererComponent } from 'src/app/core/grid-renderer/add-btn-renderer/add-btn-renderer.component';
import { AetStateService } from 'src/app/services/aet-state.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-resolutions',
    templateUrl: './resolutions.component.html',
    styleUrls: ['./resolutions.component.scss'],
    standalone: false // NOSONAR
})
export class ResolutionsComponent implements OnInit {

  faChevronRight = faChevronRight;
  gridApi: any;
  rowHeight = 30;
  defaultColDef: {};
  columnDefs: any[] = [];
  paginationPageSize: number = 10;
  icons: {};
  rowClassRules: any;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  totalPage: number = 0;
  displayRowData: any[] = [];
  currentPageForTotalPage!: number;
  isLastPageFound!: boolean;
  rowCount: number = 0;
  historyRowData: any;
  gridOptions: any;
  name: any;
  errorMessage: any;
  successMessage: any;
  eventId: string;
  eventData: any;
  eventType: any;
  plannedUnload: string;
  eventRegion: string;
  eventRoute: string;
  eventEta: string;
  eventStatus: string;
  reOpen: boolean;
  check: boolean = false;
  fromDashboard: boolean = false;
  faAddResolution = faPlus;
  faEditresolution = faPencil;
  context:any;
  isAccessible=true;

  constructor(  private readonly dialog : MatDialog,
    private readonly resolutionsService: ResolutionsService,
     private readonly eventService : EventService,
     private readonly route : ActivatedRoute,
     private readonly router : Router,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
     private readonly aetStateService : AetStateService,
    private  readonly constants: Constants) {
      this.context = {
        componentParent: this,
      };
    this.defaultColDef = {
      suppressPaginationPanel: true,
      autoHeight: true,
    }
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">'
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0', // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0', // NOSONAR
    };
  }

  findEventType(id,data, name) {
    for(let i=0;i<data.length;i++){
      if(data[i][name] == id){ // NOSONAR
        return data[i].description;
      }
    }
    return "";
  }

  navAddResolutions(){
    this.router.navigate(['/dashboard/resolutions/add-resolution']);
  }

  findLP(data, id){
    for(let i=0;i<data.length;i++){
      if(data[i].vendorId == id){ // NOSONAR
        return data[i].vendorName;
      }
    }
    return "";
  }

  etaFormat(date) {
    if(date) {
      const value = moment(date).format('MM/DD/YYYY HH:mm') ;
      return value;
    }else {
      return "";
    }

  }
  findRegionDescription(regionCode, regionList){

    for(let i=0;i<regionList.length;i++){
       if(regionList[i].itemCode == regionCode){ // NOSONAR
         return regionList[i].itemDesc;
       }
     }
     return "";
  }


  loadEventData() {
    this.successMessage=null;
    this.errorMessage=null;
    let fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    let upn = fgaDetails?.user?.userPrincipalName;
    let roles = fgaDetails?.roles?.map(r => r.displayName);
    let lpCodes = this.getUserAttribute('additionalLpCode')  ?.split(',')  ?.map(code => code.trim()) || [];
      console.log(lpCodes);
    this.fromDashboard = this.route.snapshot.pathFromRoot.flatMap((val)=> val.url.join('')).join('/').includes('dashboard');
    const data = {
      eventId: this.eventId,
      pageNo: this.fromDashboard? '0':'1',
      pageSize: '50'
    };
    this.eventService.getEventDetails(data, upn, roles, lpCodes).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.eventData = res;

          this.eventType = this.findEventType(this.eventData.editEvent.eventTypeId, this.eventData.eventTypeList, 'eventTypeId');
          this.plannedUnload = this.etaFormat(this.eventData.editEvent.arrival);
          this.eventRegion = this.  findRegionDescription(this.eventData.editEvent.region, this.eventData.regionList);
          this.eventRoute = this.eventData.editEvent.puRoute;
          this.eventEta = this.etaFormat(this.eventData.editEvent.eta);

          this.eventStatus = this.findEventType(this.eventData.editEvent.statusId,this.eventData.eventStatuses, 'statusId');
          if(this.eventStatus == 'Closed') { // NOSONAR
            this.reOpen = false;
          } else {
            this.reOpen = true;
          }

        if (res.resolutionSize > 0) {
          this.check = true;
          this.apiCall();
        }
        else
        {this.displayRowData=[ ];}
      },
      error: (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
      }
    })
  }


    getUserAttribute(key: string): any {

    let fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));

    return fgaDetails?.user?.applicationUserAttribute
      ?.flatMap(app => app.userAttributes)
      ?.find(attr => attr.key === key)
      ?.value;
  }	
  
  ngOnInit(): void {
    // this.checkRoles();
    this.eventStatus = '';
    this.reOpen = false;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.errorMessage = null;
    this.successMessage = null;

    this.eventId = '';
    this.eventType = '';
    this.plannedUnload = '';
    this.eventRegion = '';
    this.eventRoute = '';
    this.eventEta = '';

    if(localStorage.getItem('eventId')) {
      this.eventId = localStorage.getItem('eventId');
    }

    this.loadEventData();
    this.columnDefs = [
      {
        headerName: "TYPE", field: "resolution_type", sortable: true,
        unSortIcon: true,
         minWidth: 90, 
        maxWidth: 120,
      },
      {
        headerName: "LOAD NUMBER", field: "load_number", unSortIcon: true,
        sortable: true,
         minWidth: 130, 
        // maxWidth: 150,
      },
      {
        headerName: "STATUS", field: "status", sortable: true,
        unSortIcon: true,
         minWidth: 90, 
        maxWidth: 120,
      },
      {
        headerName: "ETA", field: "eta", sortable: true,
        unSortIcon: true,
        minWidth: 120, 
        maxWidth: 150,
        valueFormatter: this.dateFormatter
      },
      {
        headerName: "LOGISTIC PARTNER", field: "transportation_provider",
        unSortIcon: true, sortable: true,
         minWidth: 140, 
        //  maxWidth: 160,
      },
      {
        headerName: "LP NAME", field: "transportation_name", sortable: true,
        unSortIcon: true,
        minWidth: 130, 
        // maxWidth: 170,
      },
      {
        headerName: "DESTINATION", field: "destination", sortable: true,
        unSortIcon: true,
        minWidth: 110, 
        maxWidth: 140,
      },
      {
        headerName: "LAST UPDATED", field: "last_updated", sortable: true,
        unSortIcon: true,
        minWidth: 130, 
        // maxWidth: 150,
        valueFormatter: this.dateFormatter
      },
      {
        headerName: "LAST UPDATED BY", field: "last_updated_by", unSortIcon: true,
        sortable: true,
        minWidth: 130, 
        // maxWidth: 150,
      },
      {
        headerName: "   ", field: "edit",
        cellRenderer: EditBtnRendererComponent,
        cellRendererParams: { keyParam: this.fromDashboard },
        minWidth: 30, 
        maxWidth: 60,
      },
      {
        headerName: "   ", field: "add",
        cellRenderer: AddBtnRendererComponent,
        // cellRendererParams: { keyParam: this.fromDashboard },
        minWidth: 30, 
        maxWidth: 60,
      },
    ]
  }

  // async checkRoles() {
  //   await this.aetStateService.getRoles();
  //   const roles = this.aetStateService.getroleState();
  //   const userRoles = JSON?.parse(roles);
  //   if(userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter) || 
  //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) || 
  //   userRoles.includes(this.constants.LIOS_UAC_AET_LP) || userRoles.includes(this.constants.LIOS_UAC_MTMUS_Planner)
  //     ||userRoles.includes(this.constants.LIOS_UAC_MTMUS_Negotiator)||userRoles.includes(this.constants.LIOS_UAC_Portal_Administrator)
  //     ||userRoles.includes(this.constants.LIOS_UAC_Reporting_Admin)||userRoles.includes(this.constants.LIOS_UAC_Reporting_User)
  //     ||userRoles.includes(this.constants.LIOS_UAC_Route_Planner)||userRoles.includes(this.constants.LIOS_UAC_SCV_Admin)
  //     ||userRoles.includes(this.constants.LIOS_UAC_Security_Admin)||userRoles.includes(this.constants.LIOS_UAC_TEMA_AF)
  //     ||userRoles.includes(this.constants.LIOS_UAC_TEMA_Budgeting)||userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_AM)
  //     ||userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_Specialist)||userRoles.includes(this.constants.LIOS_UAC_TEMA_Purchasing)
  //     ||userRoles.includes(this.constants.LIOS_UAC_TEMA_LC)||userRoles.includes(this.constants.LIOS_UAC_TPT_Admin)
  //     ||userRoles.includes(this.constants.LIOS_UAC_TSCS_Admin)||userRoles.includes(this.constants.LIOS_UAC_WT_Administrator))){
  //     this.isAccessible = true;
  //   }
  //   else{
  //     this.router.navigate([`/home`]);
  //   }
  //   // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
  //   //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
  //   //   // this.isAccessible = true;
  //   // } else {
  //   //   this.router.navigate([`/home`]);
  //   // }
  // }

  apiCall() {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.resolutionsService.getResolutions(this.eventId).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.displayRowData = res;
        this.displayRowData = this.displayRowData.map((x: any) => {
          return {
            ...x,
            destination:x.destination == '-1'?null:x.destination, // NOSONAR
    
          };
        }); 
        this.rowCount = this.displayRowData.length;
      },
      error: (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = null;
          this.errorMessage = null;
        }, this.constants.notificationMessageTimeShort);
      }
    })
  }

  navEditResolutions(data){
    const dialogRef = this.dialog.open(
      EditResolutionComponent, {
      disableClose: true,
      width: '1000px',
      height: '510px',
      data: {
        header: 'Are you sure you want to delete this History?',
        description: `ID:  ${data.queueId} ,  Type: ${data.type}`,
        type :"edit",
        resolInfo: data
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.event == "SaveEvent") { // NOSONAR
        if(result?.response == "success"){ // NOSONAR
          this.successMessage = "Resolution ID: " + result?.resolution_id + " Successfully Updated.";
          setTimeout(() => {
            this.successMessage = null;
            this.errorMessage = null;
          }, 5000);
          this.apiCall()
        } else {
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = null;
            this.errorMessage = null;
          }, this.constants.notificationMessageTimeShort);
        }
      }else {
        this.errorMessage = result?.response;
          setTimeout(() => {
            this.successMessage = null;
            this.errorMessage = null;
          }, this.constants.notificationMessageTimeShort);
      }
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    });
  }

  dateFormatter(params) {
    return params.value ? moment.utc(params.value).format('MM/DD/YYYY HH:mm') : null;
  }
  onFilterChanged(params: FilterChangedEvent): void {
    this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
    this.rowCount = params.api?.getDisplayedRowCount();
    const check = document.getElementById('lbTotalPages').innerHTML;
    if(this.rowCount == 0 && Number(check) == 0 ){ // NOSONAR
      document.getElementById('lbCurrentPage').innerHTML='0';
    }
    }
  sizeToFit() { this.gridApi?.sizeColumnsToFit() };

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.applyTransaction({ add: this.displayRowData }); 
  }

  goToNexpage() { this.gridApi.paginationGoToNextPage() }
  goToPreviousPage() { return this.gridApi.paginationGoToPreviousPage() }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage() }
  goToLastPage() { return this.gridApi.paginationGoToLastPage()  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false;
      
    }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.setText('#lbCurrentPage', this.gridApi.paginationGetCurrentPage() + 1);
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") { // NOSONAR
      this.paginationPageSize = event.target.value;
      
    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }
  setText(selector: string, text: any) {
    if (this.rowCount > 0) {
      (document.querySelector(selector) as any).innerHTML = text;
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }
}



